import { useStore } from '@/store';
import klarnaService from '@/services/KlarnaService';
import eventBus from '@/services/EventBus';
class CheckoutService {
    submit() {
        eventBus.emit('ShowLoadingOverlay');
        const store = useStore();
        if (!store.getters.isLogin && store.state.blue.guest_registration_data.shouldRegister) {
            const cart = store.state.blue.cart;
            if (!cart) {
                return Promise.reject('Missing cart!');
            }
            const shippingAddress = cart.addresses.shipping;
            if (!shippingAddress) {
                return Promise.reject('Missing Shipping Address!');
            }
            const registerData = {
                firstName: shippingAddress.first_name,
                lastName: shippingAddress.last_name,
                email: cart.email,
                password: store.state.blue.guest_registration_data.password,
                confirmedPassword: store.state.blue.guest_registration_data.password,
            };
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return store.dispatch('account/REGISTER', registerData).then(() => this.runSubmit());
        }
        return this.runSubmit();
    }
    runSubmit() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return (useStore()
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            .dispatch('blue/START_CHECKOUT')
            .then((result) => {
            return this.doSubmit(result)
                .then(() => {
                return Promise.resolve(true);
            })
                .catch((reason) => {
                eventBus.emit('HideLoadingOverlay');
                return Promise.reject(reason);
            });
        })
            .catch((reason) => {
            this.failGetCartLock(reason);
            return Promise.reject(reason);
        }));
    }
    get currentPaymentType() {
        return useStore().getters.currentPaymentType;
    }
    doSubmit(result) {
        if (!useStore().state.blue.checkout_is_in_progress) {
            return this.failGetCartLock('Es ist etwas schief gelaufen!');
        }
        const cart = useStore().state.blue.cart;
        if (result !== true || useStore().state.blue.valid_for_checkout !== true || !cart) {
            return Promise.reject('Warenkorb ist nicht bereit um abgeschlossen zu werden!' + result);
        }
        if (cart.payment_type_id.startsWith('klarna_')) {
            return klarnaService.submit(cart);
        }
        // does not wait for it to be redirected
        window.location.href = '/kaufen/checkoutProcess';
        return Promise.resolve(true);
    }
    failGetCartLock(fail) {
        console.warn(fail);
        eventBus.emit('openInfoPopup', {
            icon: 'warning',
            headline: 'Warnung',
            message: 'Der Warenkorb hat sich geändert!',
        });
        return Promise.resolve(true);
    }
}
const blueCheckoutService = new CheckoutService();
export default blueCheckoutService;
